import { ValidationRuleSchema } from 'vee-validate/dist/types/types'

const Kana: ValidationRuleSchema = {
  validate(value: string) {
    return /^([ァ-ヴ][ァ-ヴー]*)$/.test(value)
  },
}

export default Kana
